export default __webpack_public_path__ + "static/media/billboard.00959d11.svg";